<template>
  <div class="table-responsive">
    <table class="giveaway-table">
      <thead>
        <tr>
          <th v-for="(header, index) in headers" :key="index">{{ header }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in rows" :key="row">
          <td v-for="(header, index) in headers" :key="index">
            <div class="shimmer-cell" :class="getCellClass(header)"></div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "ShimmerTable",
  props: {
    headers: {
      type: Array,
      default: () => ["Item", "Type", "Value", "Start Date", "End Date", "Entries", "Status", "Actions"]
    },
    rows: {
      type: Number,
      default: 5
    }
  },
  methods: {
    getCellClass(header) {
      switch (header) {
        case "Item":
          return "item-cell";
        case "Actions":
          return "actions-cell";
        default:
          return "";
      }
    }
  }
};
</script>

<style scoped>
.table-responsive {
  overflow-x: auto;
  background: var(--secondary-color);
  border-radius: 8px;
  padding: 1px;
}

.giveaway-table {
  width: 100%;
  border-collapse: collapse;
  color: white;
}

.giveaway-table th,
.giveaway-table td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.giveaway-table th {
  background: rgba(255, 255, 255, 0.05);
  font-weight: 600;
  white-space: nowrap;
}

.shimmer-cell {
  height: 20px;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.05) 0%,
    rgba(255, 255, 255, 0.1) 50%,
    rgba(255, 255, 255, 0.05) 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}

.item-cell {
  min-width: 250px;
}

.item-cell .shimmer-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}

.item-cell .shimmer-cell::before {
  content: "";
  width: 40px;
  height: 30px;
  background: inherit;
  border-radius: 4px;
  flex-shrink: 0;
}

.actions-cell {
  white-space: nowrap;
}

.actions-cell .shimmer-cell {
  width: 80px;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style> 